import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import {
	fetchWishlistStart,
	fetchWishlistSuccess,
	fetchWishlistFailure,
	addToWishlist,
	removeFromWishlist,
} from "../slices/wishlistSlice";
import { logout } from "../slices/authSlice";

export const fetchWishlist = () => async (dispatch) => {
	try {
		dispatch(fetchWishlistStart());
		const token = Cookies.get("ecom_user_token");
		const response = await axios.get(
			`${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-wishlist`,
			{ headers: { Authorization: `Bearer ${token}` } },
		);

		// Store full wishlist items with products
		dispatch(fetchWishlistSuccess(response.data.wishlist || []));
	} catch (error) {
		// Check for authentication errors
		if (
			error.response &&
			(error.response.status === 401 || error.response.status === 403)
		) {
			// Show toast message
			toast.error("Your session has expired. Please login again.", {
				position: "top-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			});

			Cookies.remove("ecom_user_token");
			dispatch(logout());

			// setTimeout(() => {
			//   window.location.href = '/login';
			// }, 1500);

			return; // Exit early
		}

		dispatch(fetchWishlistFailure(error.message));
	}
};

export const addItemToWishlist = (productId, variantId) => async (dispatch) => {
	try {
		const token = Cookies.get("ecom_user_token");
		await axios.post(
			`${process.env.REACT_APP_BACKEND_URL}/api/buyer/add-to-wishlist`,
			{ productId, variantId },
			{ headers: { Authorization: `Bearer ${token}` } },
		);
		dispatch(fetchWishlist()); // Refresh wishlist after addition
	} catch (error) {
		// Check for authentication errors
		if (
			error.response &&
			(error.response.status === 401 || error.response.status === 403)
		) {
			// Show toast message
			toast.error("Your session has expired. Please login again.", {
				position: "top-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			});

			Cookies.remove("ecom_user_token");
			dispatch(logout());

			// setTimeout(() => {
			//   window.location.href = '/login';
			// }, 1500);

			return; // Exit early
		}

		console.error("Error adding to wishlist:", error);
		throw error; // Re-throw to handle in component
	}
};

export const removeItemFromWishlist =
	(productId, variantId) => async (dispatch) => {
		try {
			const token = Cookies.get("ecom_user_token");
			await axios.delete(
				`${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-from-wishlist/${productId}/variant/${variantId}`,
				{ headers: { Authorization: `Bearer ${token}` } },
			);
			dispatch(removeFromWishlist({ productId, variantId }));
		} catch (error) {
			// Check for authentication errors
			if (
				error.response &&
				(error.response.status === 401 || error.response.status === 403)
			) {
				// Show toast message
				toast.error("Your session has expired. Please login again.", {
					position: "top-right",
					autoClose: 3000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
				});

				Cookies.remove("ecom_user_token");
				dispatch(logout());

				// setTimeout(() => {
				//   window.location.href = '/login';
				// }, 1500);

				return; // Exit early
			}

			console.error("Error removing from wishlist:", error);
			throw error;
		}
	};
